// extracted by mini-css-extract-plugin
export var colorSquare = "_qf-0";
export var danger = "_qf-5";
export var lightPink = "_qf-8";
export var neutralBlue = "_qf-7";
export var neutralYellow = "_qf-6";
export var normal = "_qf-1";
export var primary = "_qf-2";
export var primaryLight = "_qf-3";
export var solidBlack = "_qf-g";
export var solidGreen = "_qf-b";
export var solidLightBlue = "_qf-d";
export var solidNavy = "_qf-c";
export var solidOrange = "_qf-f";
export var solidPink = "_qf-e";
export var solidRed = "_qf-9";
export var solidYellow = "_qf-a";
export var success = "_qf-4";